import request from '@/utils/request'

const prefix = '/django_rest/referral'

export default {
  startListReferral: (companyId, campaignShortId, micrositeShortId) => {
    if (!companyId) {
      companyId = undefined
    }
    return request.get(`${prefix}/start-list-referral/`, { params: { company_id: companyId, campaign_short_id: campaignShortId, microsite_short_id: micrositeShortId } })
  },
  getJobReferralUrl: (listReferralId, jobId) => {
    return request.get(`${prefix}/get-job-referral-url/`, { params: { lReferId: listReferralId, jobId: jobId } })
  },
  getReferralShareQrCode (params) {
    return request.get('/share-qr-code/', { params })
  },
  getReferralLeaderBoard (params) {
    return request.get(`${prefix}/search-leader-board/`, { params })
  },
  getReferralUploadedCandidateCount (params) {
    return request.get(`${prefix}/candidate/upload/count/`, { params })
  },
  getReferralRewardList (params) {
    return request.get('/django_rest/client-admin/pay-reward/', { params })
  },
  payReward (params) {
    return request.post('/django_rest/client-admin/pay-reward/', params)
  },
  createExportReferralRewardTask (params) {
    return request.post('/django_rest/client-admin/reward/export-excel/', params)
  },
  getReferralRewardExportTaskInfo (params) {
    return request.get('/django_rest/client-admin/reward/export-excel/', { params })
  }
}
